import React from "react";
import Cardbenefits from "./cardBenefits";
import secure from "../../assets/benefits/secure.png";
import easyOffer from "../../assets/benefits/easyOffer.png";
import buyerAccepatance from "../../assets/benefits/buyerAcceptance.png";
import transparent from "../../assets/benefits/transparent.png";
import fast from "../../assets/benefits/fast.png";
import increasedSales from "../../assets/benefits/increasedSales.png";
import secureTransactions from "../../assets/benefits/secureTransactions.png";
import innovative from "../../assets/benefits/innovative.png";
import "./card.css";

export default function Benefits() {
  const cardData = [
    { icon: './Assets/Benefits/B1.png', text: "Rating System" },
    { icon: './Assets/Benefits/B2.png', text: "Lowest Fees" },
    { icon: './Assets/Benefits/B3.png', text: "Advertising System" },
    { icon: './Assets/Benefits/B4.png', text: "Effortless Communication" },
    { icon: './Assets/Benefits/B5.png', text: "Scam Protection" }
  ];
  return (
    <div className="w-full gradientgreenbg py-10 px-4 my-10 sm:px-0 flex flex-col items-center justify-center overflow-hidden ">
      <span className="flex flex-col font-pop text-lg justify-center items-center px-3 py-1 mb-4 bg-white rounded-lg text-gray-700 mx-auto w-fit">BENEFITS</span>
      <div className="w-[95%] md:w-[90%] m-auto grid md:grid-cols-3 xl:grid-cols-5 justify-center gap-6 my-8 overflow-hidden ">
        {cardData.map((item, index) => (
          <div className="bg-white border-light border-2 rounded-2xl py-6 px-5 flex flex-row items-center md:items-start md:flex-col gap-4" key={index}>
            <div className='bg-gray-200 rounded-full p-4 mb-2 md:mb-6 w-fit'>
              <img src={item.icon} alt="Icon" className="w-[25px] h-[25px]" />
            </div>
            <h5 className="text-2xl md:text-xl lg:text-2xl font-semibold font-pop tracking-tight text-gray-900 dark:text-black text-left">{item.text}</h5>
          </div>
        ))}
      </div>
    </div>
  );
}